module.exports = __webpack_public_path__ + "img/logisticsFreight1.png";